export const LINKS_FETCH = 'LINKS_FETCH';
export const LINKS_FETCH_SUCCESS = 'LINKS_FETCH_SUCCESS';
export const LINKS_FETCH_ERROR = 'LINKS_FETCH_ERROR';
export const linksFetch = () => ({type: LINKS_FETCH});



/** WEBPACK FOOTER **
 ** ./src/members/state/links/actions.js
 **/